import * as React from "react";
import AppBar from "@mui/material/AppBar";
import { Box, Divider, Stack, useMediaQuery } from "@mui/material";
import ButtonUX from "../../components/UI/Button/ButtonUX";
import { useLocation } from "react-router-dom";
import partenopeLogo from "../../assets/Partenope/logo.png";
import CallIcon from "@mui/icons-material/Call";
import HomeIcon from "@mui/icons-material/Home";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import HouseIcon from "@mui/icons-material/House";
import SettingsAccessibilityIcon from "@mui/icons-material/SettingsAccessibility";
function Navbar({
  isFooter,
  isRooms,
  isModal,
  isAdmin,
}: {
  isFooter?: boolean;
  isRooms?: boolean;
  isModal?: boolean;
  isAdmin?: boolean;
}) {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const navigationLinks = [
    { text: "Home", link: "/", icon: <HomeIcon /> },
    {
      text: "Immobili",
      link: isMobile ? "/explorerooms" : "/rooms",
      icon: <HouseIcon />,
    },
    {
      text: "Chi siamo",
      link: "/location",
      icon: <SettingsAccessibilityIcon />,
    },
    { text: "Raggiungici", link: "/raggiungici", icon: <LocationOnIcon /> },
    { text: "Contattaci", link: "/contact", icon: <CallIcon /> },
  ];

  const currentPageAnchorPoints = navigationLinks.map((link) => link);
  const location = useLocation();
  const isNotHome = location.pathname !== "/";
  return (
    <AppBar
      style={{
        position: "absolute",
        backgroundColor: "#fff", // Sfondo semi-trasparente
        width: "100%",
        display: "flex",
        zIndex: 2,
      }}
    >
      <Stack
        height={"70px"}
        display={"flex"}
        margin={"2px 20px"}
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={isFooter && !isMobile ? "flex-start" : "center"}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "15%",
            height: "100%",
            ml: 5,
          }}
        >
          <img
            src={partenopeLogo}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            alt="partenope Logo"
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            width: "70%",
            justifyContent: "flex-end",
          }}
        >
          {" "}
          {currentPageAnchorPoints.map((text, index) => {
            return (
              <div key={index}>
                <ButtonUX
                  isModal={isModal}
                  key={index}
                  text={text.text}
                  isFooter={isFooter}
                  hasBorder={false}
                  hasIcon={false}
                  icon={text.icon}
                  padding={isFooter ? "8px 0" : undefined}
                />
              </div>
            );
          })}
        </Box>
      </Stack>
    </AppBar>
  );
}
export default Navbar;
